import { root_props } from '../main';
import {getLocalObj, setLocalObj} from './storage';

export function is_part_time_mode() {
    return root_props.part_time_mode
}

export const product_list = [{
    avatar: "https://play-lh.googleusercontent.com/BzTNDTE6FVrP1WIwAYzWccNfxeZFCVaA-lt2PULF4n_9PNLnpk255Sxh41XII1QYBQ=s96-rw",
    name: "ColorFlow",
    key: "colorflow"
}, {
    // TODO: 上架后替换为 Wild Colors 的应用图标 (happy.color.number.wild.free.paint)
    avatar: "https://play-lh.googleusercontent.com/BzTNDTE6FVrP1WIwAYzWccNfxeZFCVaA-lt2PULF4n_9PNLnpk255Sxh41XII1QYBQ=s96-rw",
    name: "Wild Colors",
    key: "wild"
}, {
    // TODO: 上架后替换为 Dark Fantasy 的应用图标 (com.zizzo.darkfantasycolor)
    avatar: "https://play-lh.googleusercontent.com/BzTNDTE6FVrP1WIwAYzWccNfxeZFCVaA-lt2PULF4n_9PNLnpk255Sxh41XII1QYBQ=s96-rw",
    name: "Dark Fantasy",
    key: "dark_fantasy"
},
// Fun Color 暂不开放 CMS 产品切换
// {
//     avatar: "https://play-lh.googleusercontent.com/BzTNDTE6FVrP1WIwAYzWccNfxeZFCVaA-lt2PULF4n_9PNLnpk255Sxh41XII1QYBQ=s96-rw",
//     name: "Fun Color",
//     key: "fun_color"
// }
]

export function getProductList() {
    return product_list
}

export function getProduct() {
    if (root_props.product) {
        if (!product_list.some(p => p.key === root_props.product.key)) {
            root_props.product = product_list[0]
            setLocalObj('product', root_props.product)
        }
        return root_props.product
    } else {
        let product = getLocalObj('product', null);
        if (!product || !product_list.some(p => p.key === product.key)) {
            product = product_list[0]
            setLocalObj('product', product)
        }
        root_props.product = product
        return root_props.product
    }
}

export function changeProduct(p) {
    root_props.product = p
    setLocalObj('product', p);
    return root_props.product
}
